// Cascading geography master-data configuration.
// Each entity lists its parent chain (in order, from top-most to immediate parent).

export const GEO_CONFIGS = {
  country: {
    key: "country",
    label: "Country",
    labelPlural: "Countries",
    apiPath: "countries",
    parents: [],
  },
  state: {
    key: "state",
    label: "State",
    labelPlural: "States",
    apiPath: "states",
    parents: ["country"],
  },
  district: {
    key: "district",
    label: "District",
    labelPlural: "Districts",
    apiPath: "districts",
    parents: ["country", "state"],
  },
  city: {
    key: "city",
    label: "City",
    labelPlural: "Cities",
    apiPath: "cities",
    parents: ["country", "state", "district"],
  },
  taluk: {
    key: "taluk",
    label: "Taluk",
    labelPlural: "Taluks",
    apiPath: "taluks",
    parents: ["country", "state", "district", "city"],
  },
  area: {
    key: "area",
    label: "Area",
    labelPlural: "Areas",
    apiPath: "areas",
    parents: ["country", "state", "district", "city", "taluk"],
  },
  street: {
    key: "street",
    label: "Street",
    labelPlural: "Streets",
    apiPath: "streets",
    parents: ["country", "state", "district", "city", "taluk", "area"],
  },
  pincode: {
    key: "pincode",
    label: "Pincode",
    labelPlural: "Pincodes",
    apiPath: "pincodes",
    parents: ["country", "state", "district", "city", "taluk", "area", "street"],
  },
};

// Flat master-data entities (no parent chain). `extraFields` may include:
//   { key, label, type: "text" | "logo" }
export const FLAT_CONFIGS = {
  company: {
    key: "company",
    label: "Company",
    labelPlural: "Companies",
    apiPath: "companies",
    extraFields: [{ key: "logo", label: "Logo", type: "logo" }],
  },
  wheelCount: {
    key: "wheelCount",
    label: "Number of Wheels",
    labelPlural: "Number of Wheels",
    apiPath: "wheel_counts",
    extraFields: [],
  },
  vehicleBrand: {
    key: "vehicleBrand",
    label: "Vehicle Brand",
    labelPlural: "Vehicle Brands",
    apiPath: "vehicle_brands",
    extraFields: [],
  },
  engineStrokeType: {
    key: "engineStrokeType",
    label: "Engine Stroke Type",
    labelPlural: "Engine Stroke Types",
    apiPath: "engine_stroke_types",
    extraFields: [],
  },
  cylinderCategory: {
    key: "cylinderCategory",
    label: "Category of Cylinder",
    labelPlural: "Categories of Cylinder",
    apiPath: "cylinder_categories",
    extraFields: [],
  },
  fuelAccessPrefix: {
    key: "fuelAccessPrefix",
    label: "Fuel Access Prefix",
    labelPlural: "Fuel Access Prefixes",
    apiPath: "fuel_access_prefixes",
    extraFields: [],
  },
  cylinderCapacity: {
    key: "cylinderCapacity",
    label: "Cylinder Capacity",
    labelPlural: "Cylinder Capacities",
    apiPath: "cylinder_capacities",
    extraFields: [],
  },
  testYear: {
    key: "testYear",
    label: "Test Year",
    labelPlural: "Test Years",
    apiPath: "test_years",
    extraFields: [],
  },
};

// Hybrid entities: parents + extraFields (possibly skipping some geo levels).
export const HYBRID_CONFIGS = {
  retailOutlet: {
    key: "retailOutlet",
    label: "Retail Outlet",
    labelPlural: "Retail Outlets",
    apiPath: "retail_outlets",
    parents: ["country", "state", "district", "city", "taluk", "area", "street", "pincode"],
    namePlaceholder: "Enter Name",
    columns: 2,
    extraFields: [
      {
        key: "company_id",
        label: "Company",
        type: "select",
        optionsApiPath: "companies",
        placeholder: "Select Company",
      },
      { key: "phone", label: "Phone", type: "text", placeholder: "Enter Phone" },
      { key: "address", label: "Address", type: "textarea", placeholder: "Enter Address" },
    ],
  },
  testingAgency: {
    key: "testingAgency",
    label: "Testing Agency",
    labelPlural: "Testing Agencies",
    apiPath: "testing_agencies",
    parents: ["country", "state", "district", "taluk", "area", "street", "pincode"],
    namePlaceholder: "Enter Name",
    columns: 2,
    extraFields: [
      { key: "phone", label: "Phone", type: "text", placeholder: "Enter Phone" },
      { key: "address", label: "Address", type: "textarea", placeholder: "Enter Address" },
    ],
  },
};

export const parentFieldName = (parentKey) => `${parentKey}_id`;
